package one.healthium.log_food.ui.navigation.add_food

import com.arkivanov.decompose.ComponentContext
import one.healthium.profile.ui.food.models.FoodUiModel

class DefaultAddFoodComponent(
    componentContext: ComponentContext,
    override val food: FoodUiModel,
    private val onFoodAdded: () -> Unit,
) : AddFoodComponent, ComponentContext by componentContext {
    override fun onFoodAdded() {
        onFoodAdded.invoke()
    }
}